<template>
  <v-dialog v-model="dialog" persistent max-width="100%">
    <v-card>
      <v-card-title class="pt-2 pb-0">RECHAZAR IMPORTE Y CREAR SOLICITUD</v-card-title>

      <v-divider class="my-2"></v-divider>

      <v-card-text class="pb-0">
        <v-row dense>
          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Solicitud N°: </strong>{{ form.numero }} </span>
            <span class="h5 d-block"> <strong>Solicitante: </strong>{{ form.user }} </span>
            <span class="h5 d-block"> <strong>Fecha Solicitud: </strong>{{ form.created_at }} </span>
          </v-col>

          <v-col cols="12" md="6">
            <span class="h5 d-block"> <strong>Estado Solicitud: </strong>{{ form.estado }} </span>
            <span class="h5 d-block">
              <strong>Tipo Solicitud: </strong>{{ form.tipo == tipoSolicitudRecursos ? 'Sedes' : 'Nacional' }}
            </span>
          </v-col>
        </v-row>

        <v-row dense>
          <v-col cols="12">
            <ag-grid-vue
              :gridOptions="gridOptions"
              class="ag-theme-balham ag-grid-table-rechazar-importe"
              :columnDefs="columnDefs"
              :defaultColDef="defaultColDef"
              @grid-ready="onGridReady"
              :rowData="form.detalle_solicitud"
              :suppressRowClickSelection="true"
              colResizeDefault="shift"
              :animateRows="true"
              :floatingFilter="false"
              :rowClassRules="rowClassRules"
              :pinnedBottomRowData="pinnedBottomRowData"
              :alwaysShowVerticalScroll="true"
              :suppressPaginationPanel="true"
              @first-data-rendered="onFirstDataRendered">
            </ag-grid-vue>
          </v-col>
        </v-row>
      </v-card-text>

      <v-divider class="my-2"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar()"> Cerrar </v-btn>
        <v-btn color="blue darken-1" text @click.prevent="validar()"> Guardar </v-btn>
      </v-card-actions>
    </v-card>

    <ConfirmacionAccion
      ref="confirmacionAccion"
      :titulo="accion.titulo"
      :mensaje="accion.mensaje"
      :realizandoAccion="accion.realizandoAccion"
      maxWidth="1200"
      @cerrar="cerrarAccion"
      @aceptar="aceptarAccion">
      <v-form>
        <v-row dense>
          <v-col cols="12">
            <v-textarea
              ref="observacionRef"
              outlined
              name="observaciones"
              label="Observaciones Rechazo Importe Original*"
              hide-details
              rows="4"
              v-model="observaciones"></v-textarea>

            <span style="color: red">* Verifique la observacion por defecto</span>
          </v-col>
        </v-row>
      </v-form>
    </ConfirmacionAccion>
  </v-dialog>
</template>

<script>
import { AgGridVue } from 'ag-grid-vue';
import {
  ESTADOS_DETALLE_SOLICITUD,
  ESTADOS_SOLICITUD,
  formatearValorAMoneda,
  obtenerColorEstadoDetalleSolicitud,
  TIPOS_SOLICITUD,
} from '../utils';
import ConfirmacionAccion from '@/components/ConfirmacionAccion';
import SolicitudServices from '../services/solicitud';

export default {
  name: 'ModalRechazarImporte',
  components: {
    AgGridVue,
    ConfirmacionAccion,
  },
  computed: {
    totalImporteActual() {
      return this.form.detalle_solicitud.reduce((a, b) => a + parseFloat(b.importe), 0);
    },
    pinnedBottomRowData() {
      return [
        {
          detalle: 'TOTAL IMPORTE',
          importe_original: this.form.detalle_solicitud.reduce((a, b) => a + parseFloat(b.importe_original), 0),
          importe: this.totalImporteActual,
        },
      ];
    },
  },
  data() {
    return {
      gridOptions: {
        suppressPropertyNamesCheck: true,
        suppressMovableColumns: true,
        localeText: {
          noRowsToShow: 'No hay filas para mostrar',
          contains: 'Contiene',
          notContains: 'No Contiene',
          equals: 'Es Igual',
          notEqual: 'No es Igual',
          startsWith: 'Comienza con',
          endsWith: 'Termina con',
          filterOoo: 'Filtral...',
        },
      },
      rowClassRules: null,
      gridApi: null,
      gridColumnApi: null,
      defaultColDef: {
        sortable: false,
        resizable: true,
        suppressMenu: false,
      },
      columnDefs: [
        {
          headerName: '#',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              return param.node.rowIndex + 1;
            }
          },
          filter: false,
          minWidth: 70,
          maxWidth: 70,
        },
        {
          headerName: 'SEDE ORIGEN',
          field: 'sede_origen',
          filter: false,
          minWidth: 145,
          maxWidth: 145,
        },
        {
          headerName: 'BANCO ORIGEN',
          field: 'banco_origen',
          filter: false,
          minWidth: 145,
          maxWidth: 145,
        },
        {
          headerName: 'CUENTA ORIGEN',
          field: 'cuenta_origen',
          filter: false,
          minWidth: 145,
          maxWidth: 145,
        },
        {
          headerName: 'SEDE DESTINO',
          field: 'sede_destino',
          filter: false,
          minWidth: 145,
          maxWidth: 145,
        },
        {
          headerName: 'BANCO DESTINO',
          field: 'banco_destino',
          filter: false,
          minWidth: 145,
          maxWidth: 145,
        },
        {
          headerName: 'CUENTA DESTINO',
          field: 'cuenta_destino',
          filter: false,
          minWidth: 145,
          maxWidth: 145,
        },
        {
          headerName: 'CUENTA',
          field: 'clasificador',
          filter: false,
          minWidth: 170,
          maxWidth: 170,
        },
        {
          headerName: 'CONTABLE',
          field: 'cuenta_contable',
          filter: false,
          minWidth: 170,
          maxWidth: 170,
        },
        {
          headerName: 'DETALLE',
          field: 'detalle',
          singleClickEdit: true,
          filter: false,
          minWidth: 170,
          // maxWidth: 170,
        },
        {
          headerName: 'IMPORTE ORIGINAL',
          field: 'importe_original',
          valueFormatter: function (param) {
            return formatearValorAMoneda(param.value);
          },
          valueParser: numberParser,
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'IMPORTE ACTUAL',
          field: 'importe',
          editable: function (param) {
            if (param.node.rowPinned) {
              return false;
            } else {
              return true;
            }
          },
          singleClickEdit: true,
          cellStyle: function (params) {
            if (
              (parseFloat(params.value) == parseFloat(params.data.importe_original) || parseFloat(params.value) <= 0) &&
              !params.node.rowPinned
            ) {
              return { color: '#af0808', backgroundColor: '#e5878759' };
            }
            return {
              color: 'black',
              backgroundColor: 'transparent',
            };
          },
          valueFormatter: function (param) {
            return formatearValorAMoneda(param.value);
          },
          valueParser: numberParser,
          filter: false,
          minWidth: 140,
          maxWidth: 140,
        },
        {
          headerName: 'SALDO',
          field: 'saldo',
          valueFormatter: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            }
            return formatearValorAMoneda(param.value);
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
        {
          headerName: 'ESTADO',
          cellRenderer: function (param) {
            if (param.node.rowPinned) {
              return undefined;
            } else {
              const color = obtenerColorEstadoDetalleSolicitud(param.data.estado);

              return /*html */ `<span style="color: ${color};">${param.data.estado}</span>`;
            }
          },
          filter: false,
          minWidth: 100,
          maxWidth: 100,
        },
      ],
      dialog: false,
      tipoSolicitudRecursos: TIPOS_SOLICITUD.RECURSOS,
      observaciones: null,
      observacionesNuevoDetalleSolicitud: null,
      estadoNuevoDetalleSolicitud: null,
      form: {
        id: null,
        numero: null,
        created_at: null,
        estado: null,
        sede_origen: null,
        sede_origen_id: null,
        tipo: null,
        user: null,
        user_id: null,
        detalle_solicitud: [],
      },
      formularioEnviado: false,
      accion: {
        titulo: '',
        mensaje: '',
        realizandoAccion: false,
      },
    };
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    async abrir(data, indice) {
      this.dialog = true;
      this.form.id = data.id;
      this.form.numero = data.numero;
      this.form.created_at = data.created_at;
      this.form.estado = data.estado;
      this.form.sede_origen = data.sede_origen;
      this.form.sede_origen_id = data.sede_origen_id;
      this.form.tipo = data.tipo;
      this.form.user = data.user;
      this.form.user_id = data.user_id;
      const { importe, ...detalle } = data.detalle_solicitud[indice];
      this.form.detalle_solicitud = [
        {
          ...detalle,
          importe_original: importe,
          importe: importe,
          detalle_solicitud_rechazado_id: detalle.id,
        },
      ];
    },
    cerrar() {
      this.dialog = false;
    },
    validar() {
      if (this.form.detalle_solicitud.length > 0) {
        const importeActual = this.form.detalle_solicitud[0].importe;
        const importeOriginal = this.form.detalle_solicitud[0].importe_original;

        if (parseFloat(importeActual) > 0) {
          if (parseFloat(importeActual) != parseFloat(importeOriginal)) {
            const cuentaContable = this.form.detalle_solicitud[0].cuenta_contable;
            const usuario =
              `${this.$store.state.DATA_USER.nombres} ${this.$store.state.DATA_USER.pri_apellido} ${this.$store.state.DATA_USER.seg_apellido}`
                .trim()
                .toUpperCase();

            this.observacionesNuevoDetalleSolicitud = `Aprobado por ${usuario} de la solicitud N° ${this.form.numero} con el detalle de solicitud con el importe (original) de ${importeOriginal} al importe (actual) de ${importeActual}`;
            this.estadoNuevoDetalleSolicitud = ESTADOS_DETALLE_SOLICITUD.APROBADO;

            this.accion.titulo = '¿SEGURO DE CREAR UNA NUEVA SOLICITUD Y RECHAZAR EL IMPORTE DEL DETALLE DE SOLICITUD?';
            this.accion.mensaje = /*html*/ `Se creará una nueva solicitud con la siguiente información
      <hr class="my-2">
      <div class="row row--dense">
        <div class="col-md-4 col-12">
          <h5 class="mb-0">SOLICITUD</h5>
          <strong>SOLICITANTE</strong>: ${this.form.user}
          <br><strong>ESTADO</strong>:${ESTADOS_SOLICITUD.ATENDIDO}
          <br><strong>TIPO SOLICITUD</strong>: ${this.form.tipo == TIPOS_SOLICITUD.RECURSOS ? 'Sedes' : 'Nacional'}
        </div>

        <div class="col-md-8 col-12">
          
          <div class="row row--dense">
            <div class="col-12">
              <h5 class="mb-0">DETALLE DE SOLICITUD</h5>
            </div>

            <div class="col-md-6 col-12">
              <strong>BANCO ORIGEN</strong>: ${this.form.detalle_solicitud[0].banco_origen}
              <br><strong>CUENTA ORIGEN</strong>: ${this.form.detalle_solicitud[0].cuenta_origen}
              <br><strong>SEDE DESTINO</strong>: ${this.form.detalle_solicitud[0].sede_destino}
              <br><strong>BANCO DESTINO</strong>: ${this.form.detalle_solicitud[0].banco_destino}
              <br><strong>CUENTA DESTINO</strong>: ${this.form.detalle_solicitud[0].cuenta_destino}
            </div>

            <div class="col-md-6 col-12">
              <strong>CUENTA</strong>: ${this.form.detalle_solicitud[0].clasificador}
              <br><strong>CONTABLE</strong>: ${cuentaContable ? cuentaContable : '-'}
              <br><strong>DETALLE</strong>: ${this.form.detalle_solicitud[0].detalle}
              <br><strong>ESTADO</strong>: ${this.estadoNuevoDetalleSolicitud}
              <br><strong>IMPORTE (ACTUAL)</strong>: ${importeActual}
              <br><strong>OBSERVACIÓN</strong>: ${this.observacionesNuevoDetalleSolicitud}
            </div>
          </div>
        </div>
      </div>
      <hr class="my-2">
      Se rechazará el importe del detalle de solicitud con la siguiente observación:
      `;

            this.observaciones = `Rechazado por ${usuario} del importe (original) de ${importeOriginal} al importe (actual) de ${importeActual}`;

            this.$refs.confirmacionAccion.abrir();
          } else {
            this.$notify({
              group: 'notifications',
              title: 'Error',
              text: 'El importe (actual) debe ser mayor o menor al importe original',
              type: 'error',
            });
          }
        } else {
          this.$notify({
            group: 'notifications',
            title: 'Error',
            text: 'El importe (actual) debe ser mayor a 0',
            type: 'error',
          });
        }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe agregar al menos un detalle de solicitud',
          type: 'error',
        });
      }
    },
    async aceptarAccion() {
      if (this.observaciones) {
        if (!this.formularioEnviado) {
          this.accion.realizandoAccion = true;

          try {
            this.form.detalle_solicitud[0].observaciones = this.observacionesNuevoDetalleSolicitud;
            this.form.detalle_solicitud[0].estado = this.estadoNuevoDetalleSolicitud;
            const data = {
              observaciones: this.observaciones,
              total: this.totalImporteActual,
              ...this.form,
            };

            await SolicitudServices.storeImporteDetalleSolicitudRechazado(data);

            this.$emit('actualizarEstdoDetalleSolicitud', {
              id: this.form.detalle_solicitud[0].detalle_solicitud_rechazado_id,
              estado: ESTADOS_DETALLE_SOLICITUD.RECHAZADO,
            });

            this.$notify({
              group: 'notifications',
              title: 'EXITO',
              text: 'IMPORTE DE DETALLE DE SOLICITUD RECHAZADO Y NUEVA SOLICITUD CREADA',
              type: 'success',
            });

            this.observaciones = null;
            this.$refs.confirmacionAccion.cerrar();
            this.dialog = false;
          } catch (error) {
            window.console.log(error);

            this.$notify({
              group: 'notifications',
              title: 'Error',
              text: 'Error al rechazar la solicitud',
              type: 'error',
            });
          } finally {
            this.accion.realizandoAccion = false;
          }
        }
      } else {
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: 'Debe ingresar la observación de rechazo al importe original',
          type: 'error',
        });
      }
    },
    cerrarAccion() {
      this.observaciones = null;
    },
  },
};

function numberParser(params) {
  if (!isNaN(params.newValue) && params.newValue >= 0) {
    return Number(params.newValue).toFixed(2);
  } else {
    return 0;
  }
}
</script>

<style>
@import '~ag-grid-community/dist/styles/ag-grid.css';
@import '~ag-grid-community/dist/styles/ag-theme-balham.css';
.v-dialog {
  align-items: flex-start;
}

.ag-grid-table-rechazar-importe {
  height: calc(var(--vh, 1vh) * 100 - 22rem);
}
</style>